import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const EmailNotice = styled.div`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy1};

    strong {
      display: block;
      width: 100%;
      ${theme.fontStyle.text.body16_bold}
    }

    span {
      display: block;
      width: 100%;
      ${theme.fontStyle.text.body16_medium}
    }
  `}
`;

export const VerifyNotice = styled.div`
  ${({ theme }) => css`
    display: block;
    padding: 8px 0;

    p {
      display: block;
      color: ${theme.content.hierarchy1};
      word-break: keep-all;
      ${theme.fontStyle.text.body14_medium};
    }
  `}
`;

export const CodeInputBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ResendButton = styled.button`
  ${({ theme }) => css`
    display: block;
    padding: 8px;
    ${theme.fontStyle.text.body16_medium}
    color: ${theme.content.hierarchy3};
    text-decoration: underline;
    text-underline-position: under;
  `}
`;
